// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filter-number-input[data-v-77989776] {\r\n    background-color: white;\r\n    border-color: #dbdbdb;\r\n    border: 1px solid black;\r\n    color: #363636;\r\n    border-radius: 4px;\r\n    padding-bottom: calc(0.5em - 1px);\r\n    padding-left: calc(0.75em - 1px);\r\n    padding-right: calc(0.75em - 1px);\r\n    padding-top: calc(0.5em - 1px);\r\n    height: 2.5rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
